import { render, staticRenderFns } from "./current-order.vue?vue&type=template&id=e87f2a20&scoped=true&"
import script from "./current-order.vue?vue&type=script&lang=js&"
export * from "./current-order.vue?vue&type=script&lang=js&"
import style0 from "./current-order.vue?vue&type=style&index=0&id=e87f2a20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87f2a20",
  null
  
)

export default component.exports